import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  IonButton,
  IonChip,
  IonContent,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
} from "@ionic/react";
import { useToasts } from "components/Toast/toast";
import AppHeader from "components/Header/AppHeader";

import { WSemit } from "services/socket";
import {
  submitBreakerAnswer,
  submitTeamCWResults,
  submitTeamResults,
} from "services/teams";
import Spacer from "components/spacer";
import { isBreakerRound, MCQanswerEnum, parseBreaker } from "services/util";

interface props {
  teams: any;
  quiz: any;
  user: any;
  submitTeamResults: Function;
  submitTeamCWResults: Function;
  submitBreakerAnswer: Function;
}

interface validation {
  [key: string]: boolean | undefined;
}

type RouteParams = {
  roundId: string;
  teamId: string;
};

const ScoringTeam: React.FC<props> = ({
  teams,
  quiz,
  user,
  submitTeamResults,
  submitTeamCWResults,
  submitBreakerAnswer,
}) => {
  const history = useHistory();
  const { addToast } = useToasts();
  const { quizId, quizConfig } = quiz;
  const { customerId } = user.userDetails;

  let { roundId, teamId } = useParams<RouteParams>();
  let team = teams.teams.find((t: any) => t.teamId === parseInt(teamId));

  const [teamResults, setTeamResults] = useState<any>(
    roundId < quizConfig.format.rounds &&
      quizConfig.rounds[roundId].questionDetails.map((q: any, i: number) => 0)
  );

  const [crosswordResults, setCrosswordResults] = useState<any>(
    new Array(quizConfig.puzzle?.questionCount)?.fill(0)
  );

  const [loaded, setLoaded] = useState<Boolean>(false);
  const [breaker, setBreaker] = useState<number | null>(null);
  const [isTouched, setIsTouched] = useState<validation>({});
  const [isValid, setIsValid] = useState<validation>({});

  useEffect(() => {
    if (roundId < quizConfig.format.rounds) {
      teams.teams
        .find((t: any) => t.teamId === parseInt(teamId))
        .rounds[roundId]?.map((r: any, i: number) => {
          setTeamResults((prev: any) => {
            let newTeamResults = [...prev];
            newTeamResults[i] = r;
            return newTeamResults;
          });

          return true;
        });
      setLoaded(true);
    } else {
      let teamCWResults = teams.teams.find(
        (t: any) => t.teamId === parseInt(teamId)
      ).puzzle;
      if (teamCWResults[0] !== null) {
        console.log("teamCWResults[0] is NOT null");
        setCrosswordResults(teamCWResults);
      } else {
        console.log("teamCWResults[0] IS null");
      }
      setLoaded(true);
    }
    if (isBreakerRound(quizConfig, parseInt(roundId))) {
      let teamBQAnswer = teams.teams.find(
        (t: any) => t.teamId === parseInt(teamId)
      )?.breaker?.answer;
      if (teamBQAnswer >= 0) {
        setBreaker(teamBQAnswer);
      }
      setLoaded(true);
    }
    //eslint-disable-next-line
  }, [teamId, roundId, teams.teams]);

  const toggleAnswer = (index: number) => {
    let newTeamResults = [...teamResults];
    if (newTeamResults[index] === 1) newTeamResults[index] = 0;
    else newTeamResults[index] = 1;

    submitTeamResults(teamId, roundId, newTeamResults);
    setTeamResults(newTeamResults);
  };

  const checkCorrect = (index: number) => {
    return teamResults[index];
  };

  const toggleCWAnswer = (index: number) => {
    let newResults = [...crosswordResults];
    newResults[index] = newResults[index] === 0 ? 1 : 0;

    console.log(newResults);

    submitTeamCWResults(teamId, newResults);
    setCrosswordResults(newResults);
  };

  const checkCWCorrect = (index: number) => {
    return crosswordResults[index];
  };

  const submitResults = () => {
    let isBreakerValid = false;
    if (
      isBreakerRound(quizConfig, parseInt(roundId)) &&
      breaker !== null &&
      breaker >= 0
    ) {
      const proximity = Math.abs(
        parseBreaker(quizConfig.breaker.answer) - breaker
      ).toString();
      submitBreakerAnswer(teamId, quizConfig.breaker.answer, breaker);
      WSemit("updateTeam", {
        teamId,
        breaker: { answer: breaker, proximity },
        type: "breaker",
        round: roundId,
        checkboxes: teamResults,
        quizId,
        customerId,
      });
      isBreakerValid = true;
    } else if (!isBreakerRound(quizConfig, parseInt(roundId))) {
      submitTeamResults(teamId, roundId, teamResults);
      WSemit("updateTeam", {
        teamId,
        round: roundId,
        checkboxes: teamResults,
        quizId,
        customerId,
      });
      isBreakerValid = true;
    }

    if (isBreakerRound(quizConfig, parseInt(roundId))) {
      if (isBreakerValid) {
        history.goBack();
      } else {
        setIsTouched({ ...isTouched, breaker: true });
        addToast("Breaker answer is required");
      }
    } else {
      history.goBack();
    }
  };

  const submitCWResults = () => {
    submitTeamCWResults(teamId, crosswordResults);
    WSemit("updateTeam", {
      teamId,
      checkboxes: crosswordResults,
      type: "crossword",
      quizId,
      customerId,
    });
    history.goBack();
  };

  const markTouched = (e: any) => {
    setIsTouched({ ...isTouched, breaker: true });
  };

  const onChange = (e: any) => {
    let value = parseInt(e.target.value);

    if (!Number.isInteger(value) || !(breaker !== null && breaker >= 0)) {
      setIsValid({ ...isValid, breaker: false });
    } else {
      setIsValid({ ...isValid, breaker: true });
    }
    setBreaker(value);
  };

  useEffect(() => {
    if (loaded && quizConfig?.format?.hasBreaker) {
      submitBreakerAnswer(teamId, quizConfig.breaker.answer, breaker);
    }
    //eslint-disable-next-line
  }, [breaker]);

  const getPageTitle = () => {
    if (
      parseInt(roundId) === quizConfig.format.rounds &&
      quizConfig.format.isCrossword
    )
      return `CW - ${team.teamName}`;
    else return `R${parseInt(roundId) + 1} - ${team.teamName}`;
  };

  const getAnswerLetter = (question: any) => {
    return MCQanswerEnum[question.options.indexOf(question.answer)];
    //return "ZZ";
  };

  return (
    <>
      <AppHeader title={getPageTitle()} />
      <IonContent fullscreen className="ion-padding dashboard">
        <div className="container">
          <h2>Highlight correct answers</h2>
          {teamResults && roundId < quizConfig.format.rounds && (
            <>
              <IonList lines="full">
                {quizConfig.rounds[roundId].questionDetails.map(
                  (q: any, i: number) => (
                    <IonItem
                      key={i}
                      button
                      onClick={() => toggleAnswer(i)}
                      color={checkCorrect(i) ? "success" : ""}
                    >
                      {q.formatType !== "MCQ" && (
                        <IonLabel>
                          Q{i + 1}: &emsp;{q.answer}
                        </IonLabel>
                      )}
                      {q.formatType === "MCQ" && (
                        <IonLabel>
                          Q{i + 1}: &emsp;
                          <IonChip>
                            {getAnswerLetter(q)}. {q.answer}
                          </IonChip>
                        </IonLabel>
                      )}
                    </IonItem>
                  )
                )}
              </IonList>
              {isBreakerRound(quizConfig, parseInt(roundId)) && (
                <>
                  <Spacer size={30} />
                  <h2>Enter BQ answer</h2>
                  <IonList lines="full">
                    <IonItem
                      className={`${isValid.breaker && "ion-valid"} ${
                        isValid.breaker === false && "ion-invalid"
                      } ${isTouched.breaker && "ion-touched"}`}
                    >
                      <IonLabel position="floating">Breaker Answer</IonLabel>
                      <IonInput
                        type="number"
                        inputmode="numeric"
                        name="breaker"
                        placeholder="Breaker Answer"
                        value={breaker}
                        onIonChange={onChange}
                        onIonBlur={markTouched}
                      />
                      <IonNote slot="helper">
                        Enter the team's answer to the BQ
                      </IonNote>
                      <IonNote slot="error">
                        Invalid answer. A whole number is required.
                      </IonNote>
                    </IonItem>
                  </IonList>
                </>
              )}
              <Spacer size={30} />
              <IonButton onClick={submitResults}>Submit Score</IonButton>
            </>
          )}
          {parseInt(roundId) >= quizConfig.format.rounds &&
            quizConfig.format.isCrossword && (
              <>
                <IonList lines="full">
                  {quizConfig.puzzle.crosswordQuestions.map(
                    (q: any, i: number) => (
                      <IonItem
                        key={i}
                        button
                        onClick={() => toggleCWAnswer(i)}
                        color={checkCWCorrect(i) ? "success" : ""}
                      >
                        <IonLabel>
                          Q{i + 1}: {q.answer}
                        </IonLabel>
                      </IonItem>
                    )
                  )}
                </IonList>
                <IonButton onClick={submitCWResults}>Submit Score</IonButton>
              </>
            )}
        </div>
        <Spacer size="90" />
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  teams: state.teams,
  quiz: state.quiz,
  user: state.user,
});

export default connect(mapStateToProps, {
  submitTeamResults,
  submitTeamCWResults,
  submitBreakerAnswer,
})(ScoringTeam);
